"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Separator = exports.ActionContainer = exports.InfoContainer = exports.Container = void 0;
const ui_theme_1 = require("@kyruus/ui-theme");
const styled_1 = __importDefault(require("@emotion/styled"));
const CUSTOM_MARGIN = '44px';
exports.Container = styled_1.default.div `
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-flow: row wrap;
  width: 100%;
  margin-bottom: ${CUSTOM_MARGIN};
  ${({ isAboveMd }) => !isAboveMd
    ? `align-content: flex-start;
      align-items: flex-start;
    justify-items: center;
    flex-flow: column nowrap;`
    : ''}
`;
exports.InfoContainer = styled_1.default.div `
  display: flex;
  flex-flow: column nowrap;
  align-content: flex-start;
  justify-items: center;
  flex: 2;
`;
exports.ActionContainer = styled_1.default.div `
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: ${(_a) => {
    var { isAboveMd } = _a, rest = __rest(_a, ["isAboveMd"]);
    return isAboveMd ? 'unset' : (0, ui_theme_1.fromTheme)('spacing_large')(rest);
}};
  ${({ isAboveMd }) => !isAboveMd ? `justify-content: flex-start; width: 100%;` : ''}
`;
const styledConfigRemoveContentProp = {
    shouldForwardProp: (prop) => prop !== 'content'
};
exports.Separator = (0, styled_1.default)('hr', styledConfigRemoveContentProp) `
  width: 100%;
  text-align: center;
  border: none;
  border-top-width: ${(0, ui_theme_1.fromTheme)('border_width')};
  border-top-style: ${(0, ui_theme_1.fromTheme)('border_style')};
  border-top-color: ${(0, ui_theme_1.fromTheme)('color_border')};
  overflow: visible;
  height: 1px;
  margin: ${CUSTOM_MARGIN} 0 0 0;
  &::after {
    content: '${({ content }) => content}';
    font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
    font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_5')};
    line-height: 19px;
    color: ${(0, ui_theme_1.fromTheme)('color_button')};
    border-width: 2px;
    border-style: ${(0, ui_theme_1.fromTheme)('border_style')};
    border-color: ${(0, ui_theme_1.fromTheme)('color_button')};
    border-radius: 50%;
    background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
    top: -10px;
    position: relative;
    padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  }
`;
//# sourceMappingURL=AuthNBanner.styles.js.map